import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "wpc-header" }
const _hoisted_2 = {
  key: 0,
  class: "fa-solid fa-spinner fa-spin"
}
const _hoisted_3 = {
  key: 1,
  class: "fa-brands fa-whatsapp"
}
const _hoisted_4 = { class: "wpc-identity" }
const _hoisted_5 = { class: "wpc-alias" }
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary ms-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "wpc-id" }
const _hoisted_8 = { class: "wpc-header-actions" }
const _hoisted_9 = ["data-bs-target", "title"]
const _hoisted_10 = ["data-bs-target", "title"]
const _hoisted_11 = { class: "wpc-status-row" }
const _hoisted_12 = {
  key: 0,
  class: "wpc-default-badge"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "wpc-qr-panel"
}
const _hoisted_16 = { class: "wpc-qr-box" }
const _hoisted_17 = ["id"]
const _hoisted_18 = {
  key: 0,
  class: "fa-solid fa-spinner fa-spin wpc-qr-spinner"
}
const _hoisted_19 = {
  key: 0,
  class: "wpc-loading"
}
const _hoisted_20 = { class: "wpc-loading-msg" }
const _hoisted_21 = { class: "progress mx-2 my-4" }
const _hoisted_22 = ["aria-valuenow"]
const _hoisted_23 = { class: "wpc-qr-id" }
const _hoisted_24 = {
  key: 1,
  class: "wpc-scan-hint"
}
const _hoisted_25 = { class: "wpc-toggles" }
const _hoisted_26 = { class: "wpc-toggle-row" }
const _hoisted_27 = { class: "form-check form-switch wpc-switch mb-0" }
const _hoisted_28 = ["checked", "disabled"]
const _hoisted_29 = { class: "wpc-toggle-text" }
const _hoisted_30 = { class: "wpc-toggle-label" }
const _hoisted_31 = {
  key: 0,
  class: "alert p-1 ps-2 text-white text-sm alert-danger"
}
const _hoisted_32 = { class: "wpc-toggle-row" }
const _hoisted_33 = { class: "form-check form-switch wpc-switch mb-0" }
const _hoisted_34 = ["checked", "disabled"]
const _hoisted_35 = { class: "wpc-toggle-text" }
const _hoisted_36 = { class: "wpc-toggle-label" }
const _hoisted_37 = {
  key: 0,
  class: "text-sm text-secondary my-0"
}
const _hoisted_38 = { class: "wpc-toggle-row" }
const _hoisted_39 = { class: "form-check form-switch wpc-switch mb-0" }
const _hoisted_40 = ["checked", "disabled"]
const _hoisted_41 = { class: "wpc-toggle-text" }
const _hoisted_42 = { class: "wpc-toggle-label" }
const _hoisted_43 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_44 = { class: "wpc-toggle-row" }
const _hoisted_45 = { class: "form-check form-switch wpc-switch mb-0" }
const _hoisted_46 = ["checked", "disabled"]
const _hoisted_47 = { class: "wpc-toggle-text" }
const _hoisted_48 = { class: "wpc-toggle-label" }
const _hoisted_49 = { class: "text-sm text-secondary my-0" }
const _hoisted_50 = { class: "wpc-toggle-row wpc-toggle-row--last" }
const _hoisted_51 = { class: "form-check form-switch wpc-switch wpc-switch--danger mb-0" }
const _hoisted_52 = ["checked", "disabled"]
const _hoisted_53 = { class: "wpc-toggle-text" }
const _hoisted_54 = { class: "wpc-toggle-label" }
const _hoisted_55 = ["id", "aria-labelledby"]
const _hoisted_56 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_57 = { class: "modal-content px-2" }
const _hoisted_58 = { class: "modal-header" }
const _hoisted_59 = { class: "modal-title" }
const _hoisted_60 = { class: "modal-body" }
const _hoisted_61 = { class: "card-footer text-end" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = ["id", "aria-labelledby"]
const _hoisted_64 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_65 = { class: "modal-content px-2" }
const _hoisted_66 = { class: "modal-header" }
const _hoisted_67 = { class: "modal-title" }
const _hoisted_68 = { class: "modal-body" }
const _hoisted_69 = { class: "card-footer text-end" }

import WhatsAppClient from '@/services/gordaApi/WhatsAppClient'
import {computed, onBeforeUnmount, onMounted, ref, Ref} from 'vue'
import QRCode from 'qrcode'
import {ClientObserver} from '@/services/gordaApi/ClientObserver'
import {useWpClientsStore} from '@/services/stores/WpClientStore'
import {LoadingType} from '@/types/LoadingType'
import {WpClient} from "@/types/WpClient";
import {hide} from "@/helpers/ModalHelper";
import {storeToRefs} from "pinia";
import {WhatsappServices} from "@/constants/WhatsappServices";
import {useRouter} from "vue-router";

interface Props {
  client: WpClient
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Connection',
  props: {
    client: {}
  },
  setup(__props: any) {

const props = __props
const qr: Ref<string|null> = ref(null)
const connected: Ref<boolean> = ref(false)
const connecting: Ref<boolean> = ref(false)
const loading: Ref<LoadingType|null> = ref(null)
const router = useRouter()
const {enableWpNotifications, onWpNotification, offWpNotifications, deleteClient, setDefault, enableChatBot, enableAssistant, enableFull, enableAgentInTrip} = useWpClientsStore()
const {defaultClient, busy} = storeToRefs(useWpClientsStore())
const isBusy = computed(() => !!busy.value[props.client.id])
const chatUrl = computed(() => router.resolve({
  name: 'whatsapp.chat',
  params: { id: props.client.id }
}).href)

// Drives the header icon-chip gradient/icon: green+whatsapp when connected,
// blue+spinner while connecting/awaiting a QR scan/syncing, gray+whatsapp otherwise.
const iconState = computed<'connected'|'connecting'|'disconnected'>(() => {
  if (connected.value) return 'connected'
  if (connecting.value || qr.value || loading.value) return 'connecting'
  return 'disconnected'
})

// Drives the status pill label/color in the same precedence as the legacy markup.
const statusKey = computed<'connected'|'syncing'|'awaiting_scan'|'generating_code'|'disconnected'>(() => {
  if (connected.value) return 'connected'
  if (loading.value) return 'syncing'
  if (qr.value) return 'awaiting_scan'
  if (connecting.value) return 'generating_code'
  return 'disconnected'
})

let wpClient: WhatsAppClient
let observer: ClientObserver

function auth() {
  connecting.value = true
  wpClient.auth()
}

const onUpdate = (socket: WhatsAppClient): void => {
  connecting.value = false
  qr.value = socket.qr
  loading.value = socket.loading
  // width kept below .wpc-qr-box's 176px so the QR is never clipped
  if (qr.value) QRCode.toCanvas(document.getElementById(props.client.id), qr.value as string, { width: 160 }, (e) => {console.log(e)})
  connected.value = socket.isConnected()
  connecting.value = socket.isConnecting()
}

async function deleteWpClient(): Promise<void> {
  hide('delete-client' + props.client.id)
  wpClient.destroy()
  await deleteClient(props.client)
}

async function restartWpClient(): Promise<void> {
  hide('restart-client' + props.client.id)
  wpClient.reset()
  connecting.value = true
}

onBeforeUnmount(() => {
  offWpNotifications(props.client)
  wpClient.detach(observer)
})

onMounted(() => {
  onWpNotification(props.client)
  wpClient = WhatsAppClient.getInstance(props.client)
  observer = new ClientObserver(onUpdate)
  wpClient.attach(observer)
  connected.value = wpClient.isConnected()
  wpClient.requestState()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["wpc-card", { 'wpc-card--default': _unref(defaultClient) === __props.client.id }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["wpc-icon-chip", 'wpc-icon-chip--' + iconState.value])
        }, [
          (iconState.value === 'connecting')
            ? (_openBlock(), _createElementBlock("em", _hoisted_2))
            : (_openBlock(), _createElementBlock("em", _hoisted_3))
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(__props.client.alias) + " ", 1),
            (isBusy.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(__props.client.id), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "wpc-icon-btn wpc-icon-btn--restart",
            "data-bs-target": '#restart-client' + __props.client.id,
            "data-bs-toggle": "modal",
            title: _ctx.$t('common.actions.restart')
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("em", { class: "fa fa-rotate" }, null, -1)
          ]))], 8, _hoisted_9),
          _createElementVNode("button", {
            class: "wpc-icon-btn wpc-icon-btn--delete",
            "data-bs-target": '#delete-client' + __props.client.id,
            "data-bs-toggle": "modal",
            title: _ctx.$t('common.actions.delete')
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("em", { class: "fa fa-trash" }, null, -1)
          ]))], 8, _hoisted_10)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", {
          class: _normalizeClass(["wpc-status-pill", 'wpc-status-pill--' + statusKey.value])
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "wpc-status-dot" }, null, -1)),
          (statusKey.value === 'connected')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('common.chatBot.connected')), 1)
              ], 64))
            : (statusKey.value === 'syncing')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('wp.status.syncing')), 1)
                ], 64))
              : (statusKey.value === 'awaiting_scan')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('wp.status.awaiting_scan')), 1)
                  ], 64))
                : (statusKey.value === 'generating_code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('wp.status.generating_code')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.chatBot.disconnected')), 1)
                    ], 64))
        ], 2),
        (_unref(defaultClient) === __props.client.id)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('wp.placeholders.default_badge')), 1))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: "#",
              class: "wpc-default-link",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(setDefault)(props.client.id)), ["prevent"]))
            }, _toDisplayString(_ctx.$t('wp.placeholders.select_default')), 1)),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "wpc-spacer" }, null, -1)),
        (!connected.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "wpc-primary-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (auth())),
              disabled: connecting.value || loading.value || qr.value
            }, _toDisplayString(_ctx.$t('common.chatBot.connect')), 9, _hoisted_13))
          : (props.client.service === _unref(WhatsappServices).OFFICIAL)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: chatUrl.value,
                class: "wpc-chat-pill",
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("em", { class: "fas fa-message" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('wp.actions.chat')), 1)
              ], 8, _hoisted_14))
            : _createCommentVNode("", true)
      ]),
      (!connected.value && (connecting.value || qr.value || loading.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("canvas", {
                class: "wpc-qr-canvas",
                id: props.client.id
              }, null, 8, _hoisted_17), [
                [_vShow, qr.value && !connected.value]
              ]),
              (connecting.value && !qr.value)
                ? (_openBlock(), _createElementBlock("em", _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("h5", _hoisted_20, _toDisplayString(loading.value.message), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-success",
                      role: "progressbar",
                      style: _normalizeStyle('width: ' + loading.value.percent + '%'),
                      "aria-valuenow": loading.value.percent,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 12, _hoisted_22)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, _toDisplayString(__props.client.id), 1),
            (qr.value && !connected.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('wp.placeholders.scan_hint')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("input", {
              class: "form-check-input",
              name: "enable",
              type: "checkbox",
              checked: props.client.wpNotifications,
              disabled: !connected.value || isBusy.value,
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(enableWpNotifications)(props.client, !props.client.wpNotifications)), ["prevent"]))
            }, null, 8, _hoisted_28)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('common.settings.wpNotifications')), 1),
            (connected.value && !props.client.wpNotifications && !props.client.chatBot && !props.client.assistant)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.$t('common.settings.alert_notifications')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("input", {
              class: "form-check-input",
              name: "enable",
              type: "checkbox",
              checked: props.client.assistant,
              disabled: !connected.value || isBusy.value,
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(enableAssistant)(props.client, !props.client.assistant)), ["prevent"]))
            }, null, 8, _hoisted_34)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('common.settings.assistant')), 1),
            (connected.value && !props.client.assistant)
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.$t('common.settings.alert_assistant')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("input", {
              class: "form-check-input",
              name: "enable",
              type: "checkbox",
              checked: props.client.chatBot,
              disabled: !connected.value || isBusy.value,
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(enableChatBot)(props.client, !props.client.chatBot)), ["prevent"]))
            }, null, 8, _hoisted_40)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('common.settings.chatBot')), 1),
            (connected.value && !props.client.chatBot)
              ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.$t('common.settings.alert_chatBot')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("input", {
              class: "form-check-input",
              name: "enable",
              type: "checkbox",
              checked: props.client.agentInTrip,
              disabled: !connected.value || isBusy.value || !props.client.chatBot,
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(enableAgentInTrip)(props.client, !props.client.agentInTrip)), ["prevent"]))
            }, null, 8, _hoisted_46)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('common.settings.agentInTrip')), 1),
            _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('common.settings.alert_agentInTrip')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("input", {
              class: "form-check-input form-check-danger",
              name: "enableFull",
              type: "checkbox",
              checked: props.client.full,
              disabled: !connected.value || isBusy.value,
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_unref(enableFull)(props.client, !props.client.full)), ["prevent"]))
            }, null, 8, _hoisted_52)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('common.actions.toggle_full')), 1)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: "modal fade",
      id: 'delete-client' + __props.client.id,
      tabindex: "-1",
      "aria-labelledby": 'delete-client' + __props.client.id,
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("h5", _hoisted_59, _toDisplayString(_ctx.$t('common.actions.delete')), 1),
            _cache[14] || (_cache[14] = _createElementVNode("button", {
              type: "button",
              id: "closeModalButton",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, [
              _createElementVNode("span", { "aria-hidden": "true" }, "×")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('wp.placeholders.delete')), 1),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("button", {
              class: "btn btn-secondary me-2",
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(hide)('delete-client' + __props.client.id)))
            }, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
            _createElementVNode("button", {
              class: "btn btn-info",
              type: "button",
              disabled: isBusy.value,
              onClick: deleteWpClient
            }, _toDisplayString(_ctx.$t('common.actions.delete')), 9, _hoisted_62)
          ])
        ])
      ])
    ], 8, _hoisted_55),
    _createElementVNode("div", {
      class: "modal fade",
      id: 'restart-client' + __props.client.id,
      tabindex: "-1",
      "aria-labelledby": 'restart-client' + __props.client.id,
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("h5", _hoisted_67, _toDisplayString(_ctx.$t('common.actions.restart')), 1),
            _cache[15] || (_cache[15] = _createElementVNode("button", {
              type: "button",
              id: "closeModalButton",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, [
              _createElementVNode("span", { "aria-hidden": "true" }, "×")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('wp.placeholders.restart')), 1),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("button", {
              class: "btn btn-secondary me-2",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(hide)('restart-client' + __props.client.id)))
            }, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
            _createElementVNode("button", {
              class: "btn btn-info",
              type: "button",
              onClick: restartWpClient
            }, _toDisplayString(_ctx.$t('common.actions.restart')), 1)
          ])
        ])
      ])
    ], 8, _hoisted_63)
  ]))
}
}

})